/* eslint-disable prettier/prettier */
import store from "@/store"
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const roleFunctions = () => {

    const isAdminGuard = async(to, from, next) => {
        let roles = localStorage.getItem('roles')
        roles = roles.split(",")
        let ok = false
            // console.log(roles)
        for (let index = 0; index < roles.length; index++) {
            // console.log(roles[index])
            if (roles[index] == 'admin') {
                ok = true
            }
        }
        if (ok) {
            next()
        } else {
            Toast.fire({
                icon: 'error',
                title: 'Usted no cuenta con los roles autorizados',
            })
            next({ name: 'dashboard' })
        }
    }

    const isFiliadorGuard = async(to, from, next) => {
        let roles = localStorage.getItem('roles')
        roles = roles.split(",")
        let ok = false
            // console.log(roles)
        for (let index = 0; index < roles.length; index++) {
            // console.log(roles[index])
            if (roles[index] == 'filiador') {
                ok = true
            }
        }
        if (ok) {
            next()
        } else {
            Toast.fire({
                icon: 'error',
                title: 'Usted no cuenta con los roles autorizados',
            })
            next({ name: 'dashboard' })
        }
    }

    const isEditor = async(to, from, next) => {
        let roles = localStorage.getItem('roles')
        roles = roles.split(",")
        let ok = false
            // console.log(roles)
        for (let index = 0; index < roles.length; index++) {
            // console.log(roles[index])
            if (roles[index] == 'editor') {
                ok = true
            }
        }
        if (ok) {
            next()
        } else {
            Toast.fire({
                icon: 'error',
                title: 'Usted no cuenta con los roles autorizados',
            })
            next({ name: 'dashboard' })
        }
    }

    return {
        isAdminGuard,
        isFiliadorGuard,
        isEditor,
    }
}

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
})

export default roleFunctions











/* eslint-disable prettier/prettier */
/*
import store from "@/store"
const isAuthenticatedGuard =async(to, from, next)=>{
   
    const {ok} = await store.dispatch("auth/checkAuthentication")
    if(ok) next()
    else next({name:'sign-in'})
}
export default isAuthenticatedGuard
*/